<div class="clr"></div>
<div *ngIf="showProgressBar">
  <div class="lmask"></div>
</div>
<mat-toolbar class="mat-toolbar detailedcls fontPS" color="accent" style="color:#000">
  <div style="width: 100%;">
    <i class="fa fa-book icon" aria-hidden="true"></i> &nbsp; Power Supply Detailed View
  </div>
</mat-toolbar>
<div class="clr"></div>
<div *ngIf="Progressafter_load">
  <mat-toolbar class="clrDet fontPSdetails" color="accent">
    <mat-toolbar-row>
      <p class="pscenter"><b>Power Supply Name:</b> {{powerSupply.powerSupplyName}}</p>
    </mat-toolbar-row>
    <mat-toolbar-row>
      <p class="pscenter"><b>MAC Address:</b> {{powerSupply.macAddress}}</p>
    </mat-toolbar-row>
    <mat-toolbar-row>
      <p class="pscenter"><b>Street:</b> {{powerSupply.powerSupplyAddress}} &nbsp;<a target="_blank" href="https://www.google.com/maps/place/{{powerSupply.houseNumber}}+{{powerSupply.powerSupplyAddress}}+{{powerSupply.city}}+{{powerSupply.state}}+{{powerSupply.zip}}" matTooltip="Show on Map"><mat-icon> location_on</mat-icon></a></p>
    </mat-toolbar-row>
    <mat-toolbar-row>
      <p class="pscenter"><b>City:</b> {{powerSupply.city}}</p>
    </mat-toolbar-row>
    <mat-toolbar-row>
      <p class="pscenter"><b>State:</b> {{powerSupply.state}}</p>
    </mat-toolbar-row>
    <mat-toolbar-row>
      <p class="pscenter"><b>Latitude:</b> {{(gpsgreaterFlag) ? powerSupply.gpsLatitude : powerSupply.gpsLatitude | number:'.6' }}, <b>Longitude:</b> {{(gpsgreaterFlag) ? powerSupply.gpsLongitude : powerSupply.gpsLongitude | number:'.6' }}
      </p>
    </mat-toolbar-row>
  </mat-toolbar>
  <div class="clr"></div>
  <div style="padding-bottom: 50px;">
  <mat-accordion>
    <mat-expansion-panel *ngIf="showLocationEnable==1?false:true">
      <mat-expansion-panel-header style="height:45px;">
        <mat-panel-title>
          <h5><b class="fontpsaccord">Show Location</b></h5>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="clr"></div>
      <mat-toolbar color="primary">
        <div class="fontpsaccordsub"><i class="fa fa-info-circle fa-lg"></i>&nbsp;&nbsp;<b>Location Info</b></div>
      </mat-toolbar>
      <br>
      <div class="w3-row-padding fontpsaccord">
        <div class="wrapper_loc">
          <p><b>House Number:</b> {{powerSupply.houseNumber}}</p>
          <p><b>Street:</b> {{powerSupply.powerSupplyAddress}}</p>
          <p><b>Cross Street:</b> {{powerSupply.crossStreet}}</p>
          <p><b>City:</b> {{powerSupply.city}}</p>
          <p><b>State:</b> {{powerSupply.state }}</p>
          <p><b>Zip:</b> {{powerSupply.zip}}</p>
          <p><b>Business Partner Restriction:</b> {{powerSupply.businessPartnerRestriction }}</p>
          <p><b>Current Gps Latitude:</b> {{(gpsgreaterFlag) ? powerSupply.gpsLatitude : powerSupply.gpsLatitude | number:'.6' }}</p>
          <p><b>Current Gps Longitude:</b> {{(gpsgreaterFlag) ? powerSupply.gpsLongitude : powerSupply.gpsLongitude | number:'.6' }}</p>
          <p><b>Calculated Runtime(in Minutes):</b> {{powerSupply.calculatedRuntime}}</p>
          <p><b>Powers Node:</b> {{powerSupply.powersNode}}</p>
          <p><b>Special Location Details:</b> {{powerSupply.specialLocationDetails}}</p>
          <p><b>Aerial/UG:</b> {{powerSupply.aerialUnderground}}</p>
          <p><b>Pole #:</b> {{powerSupply.poleNumber}}</p>
          <p><b>Power Company:</b> {{powerSupply.utilityProvider}}</p>
          <p><b>Power Company Account #:</b> {{powerSupply.companyAccountNumber}}</p>
          <p><b>Power Company Contact Number:</b> {{powerSupply.powerCompanyContactNumber}}</p>
          <p><b>Power Company Website:</b></p><p class="weblink"><a target="_blank" href="{{powerSupply.powerCompanyWebsite}}">{{powerSupply.powerCompanyWebsite}}</a></p>
          <p><b>Power Company Account Type:</b> {{powerSupply.powerAccountType}}</p>
          <p><b>NWT Team:</b> {{nwtTeamData}}</p>
          <p><b>Meter #:</b> {{powerSupply.electricMeterNumber }}</p>
          <p><b>Map Page Number:</b> {{powerSupply.mapNumber}}</p>
          <p><b>PS Creation date:</b> {{psCreatedDate}}</p>
          <p><b>Feeds Multiple Nodes:</b> {{powerSupply.feedsMultipleNodes}}</p>
          <p><b>Previous Node Served:</b> {{powerSupply.prevNodeServed}}</p>
          <p><b>Node:</b> {{powerSupply.nodeName}}<img *ngIf="powerSupply.stormMode == 1" style="height: 30px;cursor:pointer;" matTooltip="Primary node is in Storm Mode" src="./assets/storm.png"></p>
          <p *ngIf="powerSupply.node2"><b>Node2:</b> {{powerSupply.node2}}</p>
          <p *ngIf="powerSupply.node3"><b>Node3:</b> {{powerSupply.node3}}</p>
          <p *ngIf="powerSupply.node4"><b>Node4:</b> {{powerSupply.node4}}</p>
          <p *ngIf="powerSupply.node5"><b>Node5:</b> {{powerSupply.node5}}</p>
          <p *ngIf="powerSupply.node6"><b>Node6:</b> {{powerSupply.node6}}</p>
          <p *ngIf="powerSupply.node7"><b>Node7:</b> {{powerSupply.node7}}</p>
          <p *ngIf="powerSupply.node8"><b>Node8:</b> {{powerSupply.node8}}</p>
          <p *ngIf="powerSupply.node9"><b>Node9:</b> {{powerSupply.node9}}</p>
          <p *ngIf="powerSupply.node10"><b>Node10:</b> {{powerSupply.node10}}</p>
          <p *ngIf="powerSupply.node11"><b>Node11:</b> {{powerSupply.node11}}</p>
          <p *ngIf="powerSupply.node12"><b>Node12:</b> {{powerSupply.node12}}</p>
          <p *ngIf="powerSupply.node13"><b>Node13:</b> {{powerSupply.node13}}</p>
          <p *ngIf="powerSupply.node14"><b>Node14:</b> {{powerSupply.node14}}</p>
          <p *ngIf="powerSupply.node15"><b>Node15:</b> {{powerSupply.node15}}</p>
          <p *ngIf="powerSupply.node16"><b>Node16:</b> {{powerSupply.node16}}</p>
          <p *ngIf="powerSupply.node17"><b>Node17:</b> {{powerSupply.node17}}</p>
          <p *ngIf="powerSupply.node18"><b>Node18:</b> {{powerSupply.node18}}</p>
          <p *ngIf="powerSupply.node19"><b>Node19:</b> {{powerSupply.node19}}</p>
          <p *ngIf="powerSupply.node20"><b>Node20:</b> {{powerSupply.node20}}</p>
          <p *ngIf="powerSupply.node21"><b>Node21:</b> {{powerSupply.node21}}</p>
          <p *ngIf="powerSupply.node22"><b>Node22:</b> {{powerSupply.node22}}</p>
          <p *ngIf="powerSupply.node23"><b>Node23:</b> {{powerSupply.node23}}</p>
          <p *ngIf="powerSupply.node24"><b>Node24:</b> {{powerSupply.node24}}</p>
          <p *ngIf="powerSupply.node25"><b>Node25:</b> {{powerSupply.node25}}</p>
          <p *ngIf="powerSupply.node26"><b>Node26:</b> {{powerSupply.node26}}</p>
          <p *ngIf="powerSupply.node27"><b>Node27:</b> {{powerSupply.node27}}</p>
          <p *ngIf="powerSupply.node28"><b>Node28:</b> {{powerSupply.node28}}</p>
          <p *ngIf="powerSupply.node29"><b>Node29:</b> {{powerSupply.node29}}</p>
          <p *ngIf="powerSupply.node30"><b>Node30:</b> {{powerSupply.node30}}</p>
          <p *ngIf="powerSupply.node31"><b>Node31:</b> {{powerSupply.node31}}</p>
          <p *ngIf="powerSupply.node32"><b>Node32:</b> {{powerSupply.node32}}</p>
          <p><b>Comments:</b> {{powerSupply.locationComments}}</p>
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="showTransponderEnable==1?false:true">
      <mat-expansion-panel-header class="accord_cls">
        <mat-panel-title>
          <h5><b class="fontpsaccord">Show Transponder</b></h5>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="clr"></div>
      <mat-toolbar color="primary">
        <div class="fontpsaccordsub"><i class="fa fa-info-circle fa-lg"></i>&nbsp;&nbsp;<b>Transponder/Supply
            Info</b></div>
      </mat-toolbar>
      <div class="w3-row-padding fontpsaccord">
        <br>
        <div class="w3-third font_class">
          <p><b>Active Mac Address:</b> {{powerSupply.macAddress}}</p>
          <p><b>Previous Mac Address:</b> {{powerSupply.macAddressPrevious}}</p>
          <p><b>IP:</b> {{powerSupply.ip}}</p>
          <p><b>EGIS Number:</b> {{powerSupply.egisName}}</p>
          <p><b>Global Identifier:</b> {{powerSupply.globalId}}</p>
          <p><b>Transponder Vendor:</b> {{powerSupply.transponderVendor}}</p>
          <p><b>Transponder Model:</b> {{powerSupply.transponderModel}}</p>
          <p><b>Power Supply Name:</b> {{powerSupply.powerSupplyName}}</p>
          <p><b>Power Supply Number:</b> {{powerSupply.powerSupplyNumber}}</p>
        </div>
        <div class="w3-third font_class">
          <p><b>StandBy/Non-StandBy:</b> {{powerSupply.powerSupplyType}}</p>
          <p><b>Power Supply Type (9360 Model):</b> {{powerSupply.powerSupplyType9360}}</p>
          <p><b>Power Supply Model:</b> {{powerSupply.powerSupplyModel}}</p>
          <p><b>AC Input Voltage Rating:</b> {{powerSupply.acInputVoltage}}</p>
          <p><b>AC Output Voltage Rating:</b> {{powerSupply.outputVoltage}}</p>
          <p><b>Current Amp Rating:</b> {{powerSupply.inputCurrent}}</p>
          <p><b>Power Supply Alert Profile:</b> {{powerSupply.psAlertProfile}}</p>
          <p><b>Serial Number:</b> {{powerSupply.serialNumber}}</p>
          <p><b>DC Ready:</b> {{powerSupply.dcReady}}</p>
        </div>
        <div class="w3-third font_class">
          <p><b>Priority:</b> {{powerSupply.priority}}</p>
          <p><b>Comments:</b> {{powerSupply.transponderComments}}</p>
          <p><b>Next Gen Node:</b> {{powerSupply.nextGenNode}}</p>
          <p><b>Ethernet Connected Device:</b> {{powerSupply.externalSensor}}</p>
          <div *ngIf="powerSupply.nextGenNode === 'EPON with SFP'">
          <p><b>MacAddress as Printed on the SFP:</b> {{sfpmacData.sfpMacAddress}}</p>
          <p><b>SFP Serial Number:</b> {{sfpmacData.serialNumber}}</p>
          <p><b>SFP Model:</b> {{sfpmacData.model}}</p>
          <p><b>SFP Vendor:</b> {{sfpmacData.vendor}}</p>
          <p><b>SFP BootFile Version:</b> {{sfpmacData.bootFileVersion}}</p>
          <p><b>SFP Hardware Revision:</b> {{sfpmacData.hardwareRevision}}</p>
          <p><b>SFP IPV4:</b> {{ sfpmacData.sfpIpv4 }}</p>
         </div>
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="showBatteryEnable==1?false:true">
      <mat-expansion-panel-header class="accord_cls">
        <mat-panel-title>
          <h5><b class="fontpsaccord">Show Battery</b></h5>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="clr"></div>
      <mat-toolbar color="primary">
        <div class="fontpsaccordsub"><i class="fa fa-info-circle fa-lg"></i>&nbsp;&nbsp;<b>Battery Info</b></div>
      </mat-toolbar>
      <div class="w3-row-padding fontpsaccord">
        <br>
        <div class="w3-third font_class">
          <p><b>Number Of Batteries:</b> {{powerSupply.numberOfBatteries}}</p>
        </div>
        <div class="w3-third font_class">
          <p><b>Were The Batteries Replaced(Yes or No)?:</b>{{powerSupply.batteriesReplaced}}</p>
        </div>
        <!-- <div class="w3-third font_class">
          <p><b>Battery Replacement Date:</b> {{powerSupply.batteryReplacementDate}}</p>
        </div>
        <div class="w3-third font_class">
          <p><b>Battery Manager:</b> {{powerSupply.hasBatteryBalancer}}</p>
        </div> -->
        <div class="w3-third font_class">
          <p><b>Battery Manager Model :</b> {{powerSupply.batteryBalancerString}}</p>
        </div>

        <br>
        <div class="w3-third font_class" *ngFor="let string of noOfStrings;">
          <!-- <p *ngIf="!parallelBatts"><b>Battery Manager Model : {{batteryManagerModels}}</b></p>
		  <p *ngIf="parallelBatts"><b>Battery Manager Model : {{batteryManagerModels}}</b></p> -->
        <div *ngFor="let battery of noOfBatteries;" class="w3-third font_class">
          <p *ngIf="!parallelBatts" class="bat_clr"> String {{string}} - Battery {{battery}}</p>
          <p *ngIf="parallelBatts" class="bat_clr"> String {{string}} - Parallel Battery {{battery}}</p>
          <p><b>Battery Manufacturer/Type:</b> {{batteryManufacturers.get(string + ',' + battery)}}</p>
          <p><b>Battery Serial Number:</b> {{batterySerial.get(string + ',' + battery)}}</p>
          <p><b>Battery Date Code (On Battery):</b> {{batteryDateCodes.get(string + ',' + battery)}}</p>
          <p><b>Battery 1 Install Date:</b> {{batteryInstallDates.get(string + ',' +
                    battery)}}</p>
          <p><b>Battery Voltage - No Load:</b> {{batteryVoltages.get(string + ',' + battery)}}</p>

        </div>
        </div>
        <div class="w3-third font_class">
          <p><b>Comments:</b> {{powerSupply.batteryComments}}</p>
          </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="showLastVisitEnable==1?false:true">
      <mat-expansion-panel-header class="accord_cls">
        <mat-panel-title>
          <h5><b class="fontpsaccord">Show Last Visit</b></h5>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="clr"></div>
      <mat-toolbar color="primary">
        <div class="fontpsaccordsub"><i class="fa fa-info-circle fa-lg"></i>&nbsp;&nbsp;<b>Last Visit Info</b></div>
      </mat-toolbar>
      <div class="w3-row-padding fontpsaccord">
        <br>
        <div class="w3-third font_class">
          <p><b>Type of Visit:</b> {{powerSupply.typeOfVisit}}</p>
          <p><b>Visit Status:</b> {{powerSupply.visitStatus}}</p>
          <p><b>Follow Up Reason:</b> {{powerSupply.followUpReason}}</p>
          <p><b>XOC Verified Transponder Operational:</b> {{powerSupply.xocVerified}}</p>
          <p><b>Clean Dust And Dirt From Enclosure:</b> {{powerSupply.cleanEnclosure}}</p>
          <p><b>Tighten All Enclosure Hardware:</b> {{powerSupply.tightenHardware}}</p>
          <p><b>Inspect Wire Harnesses And Connectors:</b> {{powerSupply.inspectConnectors}}</p>
          <p><b>Inspect Battery Temperature Probes:</b> {{powerSupply.inspectProbes}}</p>
          <p><b>Meter Pan Condition:</b> {{powerSupply.meterPanCondition}}</p>
          <p><b>Power Co Riser Condition:</b> {{powerSupply.powerCoRiserCondition }}</p>
        </div>
        <div class="w3-third font_class">
          <p><b>Last Visit Date:</b> {{lastvisitDate}}</p>
          <p><b>Check Seizure Screw / Alt Box:</b> {{powerSupply.checkSeizureAltBox}}</p>
          <p><b>Is Power Supply ID Legible:</b> {{powerSupply.powerSupplyIdLegible}}</p>
          <p><b>Check Lamps & LEDs:</b> {{powerSupply.checkLampsLeds}}</p>
          <p><b>Check For 20 Amp Hi-Magnetic Circuit Breaker:</b> {{powerSupply.checkMagneticBreaker}}</p>
          <p><b>Visual Inspection Of Cabinet:</b> {{powerSupply.visualCabinetInspection}}</p>
          <p><b>Cabinet Locked:</b> {{powerSupply.cabinetLocked}}</p>
          <p><b>Check Ground Connection At Cabinet:</b> {{powerSupply.checkGroundCabinet}}</p>
        </div>
        <div class="w3-third font_class">
          <p><b>Cabinet Vendor:</b> {{powerSupply.cabinetVendor}}</p>
          <p><b>Cabinet Battery Capacity:</b> {{powerSupply.cabinetBatteryCapacity}}</p>
          <p><b>Check Operating Lights:</b> {{powerSupply.checkOperatingLights}}</p>
          <p><b>Stand By Operation:</b> {{powerSupply.standByOperation}}</p>
          <p><b>Follow Up Action Needed:</b> {{powerSupply.followUpNeeded}}</p>
          <p><b>Input Surge Arrestor:</b> {{powerSupply.inputSurgeArrestor}}</p>
          <p><b>Output Surge Arrestor:</b> {{powerSupply.outputSurgeArrestor}}</p>
          <p><b>Tech:</b> {{powerSupply.commTech}}</p>
          <p><b>Comments:</b> {{powerSupply.comments}}</p>
        </div>
      </div>
    </mat-expansion-panel>
    <!--View Image Section-->
    <mat-expansion-panel *ngIf="showPhotosEnable==1?false:true" (opened)="openGroup('Show Photos')">
      <mat-expansion-panel-header class="accord_cls">
        <mat-panel-title>
          <h5><b class="fontpsaccord">Show Photos</b></h5>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-toolbar color="primary">
        <div class="fontpsaccordsub"><i class="fa fa-info-circle fa-lg yellow"></i> &nbsp;<b> Show Photos</b></div> &nbsp;&nbsp;&nbsp;&nbsp;
        <div *ngIf="xmRepBtnEnable==1?false:true" class="fontpsaccordsub"><button mat-raised-button color="primary" [disabled]="xmRepBtnEnable==2" matTooltip="Download XM360 PDF Report" (click)="downloadPDF()"><i class="fa fa-download"></i> &nbsp;<strong>XM360 Report</strong></button></div>
      </mat-toolbar>
      <mat-card *ngFor="let imagedata of detailedImage; index as i">
        <mat-card-title class="titleHeader">
          <div>{{imagedata.id+". "+imagedata.name}}</div>
          <div *ngIf="imagedata.url"><i class="fa fa-info-circle fa-lg yellow"></i> &nbsp; Image Uploaded at {{latestDateDetail[i].uploadedDate}} .</div>
        </mat-card-title>
        <mat-card-content class="imagePos">
          <br>
          <img *ngIf="imagedata.url" [src]="imagedata.url" class="imageSrc"><br>
          <img *ngIf="!imagedata.url" src="./assets/noprev.jpg" class="noPrev"><br>
        </mat-card-content>
      </mat-card>
      <hr class="bottomLine">
    </mat-expansion-panel>

    <!--Show Alerts/Events-->
    <mat-expansion-panel *ngIf="showAlertsEnable==1?false:true">
      <mat-expansion-panel-header class="accord_cls">
        <mat-panel-title>
          <h5><b class="fontpsaccord">Show Alerts/Events</b></h5>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="clr"></div>
      <mat-toolbar color="primary">
        <div class="fontpsaccordsub"><i class="fa fa-info-circle fa-lg"></i>&nbsp;&nbsp;<b>Alerts/Events Info</b></div>
      </mat-toolbar>
      <div class="w3-row-padding fontpsaccord">
        <!-- <h1 mat-dialog-title class="text-center colorFill" style="margin:0px;">Transponder Operations History</h1> -->
        <mat-form-field class="px-16" style="width: 50%">
            <input matInput [(ngModel)]="searchText" placeholder="Search..." autocomplete="off" style="width: 100%">
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
        <div *ngIf="noData" class="noResult">No Records to Show</div>
        <div *ngIf="!noData" class="wrapper">
          <!-- {{alertResult['psAlertsList'] | json}} -->
            <div *ngFor="let activealerts of alertResultData | filter: searchText; let i = index">
            <p mat-list-item><b>Power Supply Name:
            </b>{{activealerts.powerSupplyName != null ? activealerts.powerSupplyName : '-' }}
            </p>
            <p mat-list-item><b>IP Address:
                </b>{{activealerts.ip != null ? activealerts.ip : '-' }}
            </p>
            <p mat-list-item><b>Mac Address:
                </b>{{activealerts.macAddress != null ? activealerts.macAddress : '-' }}
            </p>
            <p mat-list-item><b>Alert Start Time:
                </b>{{activealerts.alertStartTime != null ? activealerts.alertStartTime : '-' }}
            </p>
            <p mat-list-item><b>Alert Duration:
                </b>{{activealerts.alertDuration != null ? activealerts.alertDuration : '-' }}
            </p>
            <p mat-list-item><b>Alert Type:
                </b>{{activealerts.alertDesc != null ? activealerts.alertDesc : '-' }}
            </p>
            <p mat-list-item><b>Alert Description:
                </b>{{activealerts.alertDetails != null ? activealerts.alertDetails : '-' }}
            </p>
            <p mat-list-item><b>Alert Level:
                </b>{{activealerts.alertLevel != null ? activealerts.alertLevel : '-' }}
            </p>
            <p mat-list-item *ngIf="activealerts.totalCustomersOffline && activealerts.totalCustomers"><b>Customers
                    Offline: </b>{{activealerts.totalCustomersOffline + '/' + activealerts.totalCustomers}}
            </p>
            <p mat-list-item><b>Impacted Devices:
                </b>{{activealerts.impactedDevices != null ? activealerts.impactedDevices : '-' }}
            </p>
            <p mat-list-item><b>PS State: </b>{{activealerts.psState == null ? '-' : (activealerts.psState == 'on_battery' ? 'on_standby' : activealerts.psState) }}</p>
            <p mat-list-item *ngIf="activealerts.psExpectedFailureTime"><b>Expected Failure Time: </b>{{ activealerts.psExpectedFailureTime }}</p>
            <p mat-list-item *ngIf="activealerts.batteryTimeMinsRemaining"><b>Battery Runtime Remaining: </b>{{ activealerts.batteryTimeMinsRemaining }} Mins</p>
            <p mat-list-item><b>Network Impact:
                </b>{{activealerts.networkImpact != null ? activealerts.networkImpact : '-' }}
            </p>
            <p mat-list-item><b>CMTS: </b>{{activealerts.cmts != null ? activealerts.cmts : '-' }}</p>
            <p mat-list-item><b>Primary Node: </b>{{activealerts.ncpnode != null ? activealerts.ncpnode : '-' }}</p>
            <!--<p mat-list-item><b>Hierarchy Path: </b>{{activealerts.hierarchyPathLabels != null ? activealerts.hierarchyPathLabels : '-' }}</p>-->
            <p mat-list-item><b>Current Score:
                </b>{{activealerts.psScoreCurrent != null ? activealerts.psScoreCurrent : '-' }}
            </p>
            <p mat-list-item><b>Alert Score:
                </b>{{activealerts.psScoreAlert != null ? activealerts.psScoreAlert : '-' }}
            </p>
                <div class="block_line" color="accent"></div>
            </div>
        </div>
      </div>
    </mat-expansion-panel>
    <!--Show History-->
    <mat-expansion-panel *ngIf="showHistoryEnable==1?false:true">
      <mat-expansion-panel-header class="accord_cls">
        <mat-panel-title>
          <h5><b class="fontpsaccord">Show History</b></h5>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="clr"></div>
      <mat-toolbar color="primary">
        <div class="fontpsaccordsub"><i class="fa fa-info-circle fa-lg"></i>&nbsp;&nbsp;<b>Log History Info</b></div>
      </mat-toolbar>
      <mat-form-field class="px-16" style="width: 50%">
        <input matInput [(ngModel)]="searchlogText" placeholder="Search..." autocomplete="off" style="width: 100%">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
      <div class="w3-row-padding fontpsaccord">
        <div *ngIf="nologData" class="noResult">No Rows to Show</div>
        <div *ngIf="!nologData" class="wrapper">
          <div *ngFor="let loghistory of loghistoryData | filter: searchlogText; let i = index">
            <p mat-list-item><b>Log Date:</b>
              {{loghistory.logDate != null ? loghistory.logDate : '-' }}
            </p>
            <p mat-list-item><b>Log NT:</b>
              {{loghistory.logNt != null ? loghistory.logNt : '-' }}
            </p>
            <p mat-list-item><b>Log Name:</b>
              {{loghistory.logName != null ? loghistory.logName : '-' }}
            </p>
            <!-- <p mat-list-item><b>Date Changes:</b>
              {{loghistory.fieldsModified != null ? loghistory.fieldsModified : '-' }}
            </p> -->
            <!-- <p mat-list-item>
              <b>Date Changes:</b> -->
            <!-- <p [innerHTML]="loghistory.fieldsModified"></p> -->
            <!-- </p> -->
            <p *ngIf="loghistory.fieldsModified != null" mat-list-item [innerHTML]="this.sanitizer.bypassSecurityTrustHtml('<span><b>Data Changes:</b>'+loghistory.fieldsModified+'</span>')"></p>
            <p *ngIf="loghistory.fieldsModified == null" mat-list-item><b>Data Changes:</b> - </p>
            <div class="block_line" color="accent"></div>
          </div>
        </div>

      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
</div>
